/* === Adega Curitibana :: enforcement mínimo 6 unidades ===
   REMOVÍVEL: para desligar, apague este arquivo e a linha
   <script src="{{ 'pdp-minqty-enforce.js' | asset_url }}" defer></script> em layout/theme.liquid.
   Regra: cada linha do carrinho que NÃO seja kit/bag in box/litro+/garrafão/magnum
   precisa de quantidade >= 6. Enquanto houver violação, o checkout fica bloqueado. */
(function () {
  var MIN = (typeof window.AC_MINQTY === 'number' && window.AC_MINQTY > 0) ? window.AC_MINQTY : 6;
  var EXEMPT = /kit|bag in box|bag-in-box|litro|garrafao|garrafão|magnum/;

  function isExempt(item) {
    var s = ((item.product_title || item.title || '') + ' ' + (item.handle || '')).toLowerCase();
    return EXEMPT.test(s);
  }

  function checkoutButtons() {
    return document.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], .cart__checkout-button, ' +
      'a[href$="/checkout"], .shopify-payment-button, .additional-checkout-buttons, [data-pdp-checkout]'
    );
  }

  function setBlocked(bad) {
    var blocked = bad.length > 0;
    checkoutButtons().forEach(function (b) {
      if (blocked) {
        b.setAttribute('disabled', 'disabled');
        b.setAttribute('aria-disabled', 'true');
        b.style.pointerEvents = 'none';
        b.style.opacity = '0.5';
      } else {
        b.removeAttribute('disabled');
        b.removeAttribute('aria-disabled');
        b.style.pointerEvents = '';
        b.style.opacity = '';
      }
    });

    var note = document.getElementById('minqty-note');
    if (blocked) {
      if (!note) {
        note = document.createElement('div');
        note.id = 'minqty-note';
        note.setAttribute('role', 'alert');
        note.style.cssText = 'margin:10px 0;padding:10px 12px;border:1px solid #b3261e;' +
          'border-radius:8px;color:#b3261e;background:#fff;font-size:13px;line-height:1.35;';
        var anchor = document.querySelector(
          '.cart__footer, .cart-drawer__summary, .cart__summary, form[action$="/cart"], .cart'
        );
        if (anchor) anchor.prepend(note); else document.body.appendChild(note);
      }
      note.textContent = 'Venda mínima de ' + MIN + ' unidades por vinho. Ajuste a quantidade de: ' +
        bad.map(function (i) { return (i.product_title || i.title) + ' (' + i.quantity + ')'; }).join('; ') + '.';
    } else if (note) {
      note.remove();
    }
  }

  var validating = false;
  function validate() {
    if (validating) return;
    validating = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bad = (cart.items || []).filter(function (it) { return !isExempt(it) && it.quantity < MIN; });
        setBlocked(bad);
      })
      .catch(function () {})
      .then(function () { validating = false; });
  }

  function init() {
    validate();
    ['cart:refresh', 'cart:change', 'cart:updated', 'cart:build'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(validate, 300); });
      window.addEventListener(ev, function () { setTimeout(validate, 300); });
    });
    document.body.addEventListener('change', function (e) {
      var t = e.target;
      if (t && (t.name === 'updates[]' || (t.closest && t.closest('.quantity-selector')))) {
        setTimeout(validate, 500);
      }
    });
    document.body.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.quantity-selector, .cart-items, .cart')) {
        setTimeout(validate, 500);
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
